// Import CSS
import styles from './WorkSpace.module.css';

const WorkSpace = (props) => {
  return <main className={styles.workSpace}>{props.children}</main>;
};

export default WorkSpace;
